export const groups = {
    "Children-and-Young-Adults": [
        "L05yAJbhq6Y",
        "XYlmYCH4t8I",
        "zo_F-7rNWg0",
        "FucFOXEZj2c"
    ],
    "Community-Event": [
        "7Vv53OpV6wU"
    ],
    "Education-History": [
        "-pmJJag2xLs",
        "pVBFhkmpje4",
        "P-ZIBMX6_3U",
        "WLm5aPZ7x4M",
        "dqUXBwpkQOs"
    ],
    "Featured": [
        "pVBFhkmpje4",
        "WLm5aPZ7x4M",
        "5WpK3B12bu4",
        "U_q4jkp8UJU",
        "50iQDFMRQpg",
        "Hy8w_2qn0as",
        "GDRR8mgHBTk",
        "hW24xBzqLE8",
        "PCT74QzzFao",
        "H13bPXEFzkk",
        "7Cajo84Yz3M",
        "_iLtzfg3dik"
    ],
    "Elders-Wisdom": [
        "LXDyg6Kotd0",
        "6DQTE6b6YQk",
        "ClklQ0IntQU",
        "vQLhJ0pxQlk",
        "52ouDZAkuvc",
        "hncI1F7ADyY"
    ],
    "Elders-Wisdom---Holiday-Traditions": [
        "oizXyqk5R1U",
        "E6HFnxvL3rw",
        "U7nclYvsQ9c"
    ],
    "Elders-Wisdom---Memories": [
        "lJn8MqurjGM",
        "-Xm9v1IGzDA",
        "uxz-q2ZiZvo",
        "5GrgzHo-OSU"
    ],
    "Elders-Wisdom---Traditional-Values": [
        "khHHc_ACqlA",
        "Uer-AItnthI",
        "xkXkFYzxypo",
        "KJQtj7e3uzg",
        "31balluMwfE",
        "0BjSTW_ZvZ4",
        "4qFx_P2CkKQ"
    ],
    "Fishing-&-Hunting": [
        "tIpwFwFE3HU"
    ],
    "Food-&-Clothing": [
        "-Pc_Taab9Qo",
        "KDMsKHYtx_U",
        "5WpK3B12bu4",
        "J8s8eMeTAtk",
        "Lljd7Yh0Bis"
    ],
    "Green-Table-RENAME": [
        "GfqAsQzt9iQ",
        "35X11kzux70",
        "THoVlwnV44g",
        "hsTpLPFlVFI",
        "u1uo02UBFoQ",
        "hLaTPSc53fI",
        "nR9p3SGBN8Y",
        "H_nE-ZMAmI8",
        "HzGl6zYmZW4",
        "5IgeHRWZ2dw",
        "sYUY5OT5Ag4",
        "0CDj4LvHnOU",
        "3s5DRwacMNI",
        "3P8jR6veulc",
        "U_q4jkp8UJU",
        "63IWdhSwF8w",
        "Vt_5bI5GmyU",
        "LRiZgAzKLbI",
        "hpDEodHWvZM"
    ],
    "Health-and-Safety": [
        "989WUAw4Ve0",
        "PYBMB-e5zyk",
        "5RFXaM2ty1E",
        "Ckj8X5vkJH0",
        "pOeLyo1_P10",
        "7fuT2DeOQiE",
        "50iQDFMRQpg",
        "mVCyBKHIsa4",
        "5lyhdh7pgOI",
        "T2cDE8ruHis",
        "QJVdoVFixd8",
        "lueW8hDOHgE",
        "Z1fIb5_GfhE"
    ],
    "Newscast": [
        "H_PWsD75rcg",
        "Hy8w_2qn0as"
    ],
    "Religion-&-Politics": [
        "akTuEB0w1aY",
        "W018Whbyq0w"
    ],
    "Storytelling": [
        "p0XAmQwenEI",
        "GDRR8mgHBTk",
        "vsDR410Q21M",
        "hW24xBzqLE8",
        "N9lX4sQZxO4"
    ],
    "Theater-and-Arts": [
        "HyBIcPLbNVM",
        "Kjcw1u0CD1g",
        "Dm9d7qBJLlM",
        "4y9W5fiOLks",
        "IruCDl1Ljio",
        "k2TEQNlt230",
        "QsqRXLq0FfY",
        "PCT74QzzFao",
        "H13bPXEFzkk",
        "Tivj5oGoNBg"
    ],
    "Yuraq": [
        "7Cajo84Yz3M",
        "_iLtzfg3dik",
        "U2JMGyhWH5U",
        "_Bpstt_S_ps"
    ]
};
export const grouplist = [
    [
        "Featured",
        "Featured"
    ],
    [
        "Children-and-Young-Adults",
        "Children and Young Adults"
    ],
    [
        "Community-Event",
        "Community Event"
    ],
    [
        "Education-History",
        "Education History"
    ],
    [
        "Elders-Wisdom",
        "Elders Wisdom"
    ],
    [
        "Elders-Wisdom---Holiday-Traditions",
        "Elders Wisdom - Holiday Traditions"
    ],
    [
        "Elders-Wisdom---Memories",
        "Elders Wisdom - Memories"
    ],
    [
        "Elders-Wisdom---Traditional-Values",
        "Elders Wisdom - Traditional Values"
    ],
    [
        "Fishing-&-Hunting",
        "Fishing & Hunting"
    ],
    [
        "Food-&-Clothing",
        "Food & Clothing"
    ],
    [
        "Green-Table-RENAME",
        "Green Table RENAME"
    ],
    [
        "Health-and-Safety",
        "Health and Safety"
    ],
    [
        "Newscast",
        "Newscast"
    ],
    [
        "Religion-&-Politics",
        "Religion & Politics"
    ],
    [
        "Storytelling",
        "Storytelling"
    ],
    [
        "Theater-and-Arts",
        "Theater and Arts"
    ],
    [
        "Yuraq",
        "Yuraq"
    ]
];